import React from 'react';
import { IconProps } from '../types';

export const IndustrialIcon = ({ color }: IconProps) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 30.6667V27.1667H2V30H5V32H1.33333C0.596954 32 0 31.4031 0 30.6667Z" fill={color} />
        <path
            d="M1.33333 1.33337H5V3.33337H2V6.16671H0V2.66671C0 1.93033 0.596954 1.33337 1.33333 1.33337Z"
            fill={color}
        />
        <path d="M2 20.1667H0V13.1667H2V20.1667Z" fill={color} />
        <path d="M12.3333 3.33337V1.33337H19.6667V3.33337H12.3333Z" fill={color} />
        <path
            d="M27 3.33337V1.33337H30.6667C31.403 1.33337 32 1.93033 32 2.66671V6.16671H30V3.33337H27Z"
            fill={color}
        />
        <path d="M30 13.1667H32V20.1667H30V13.1667Z" fill={color} />
        <path d="M30 27.1667H32V30.6667C32 31.4031 31.403 32 30.6667 32H27V30H30V27.1667Z" fill={color} />
        <path d="M19.6667 30V32H12.3333V30H19.6667Z" fill={color} />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.2727 6.88188L25 11.7455V20.2025L16.7711 25.1398L7 20.2543V11.0182L15.2727 6.88188ZM9 19.0182V13.2544L15.7272 16.618V22.3818L9 19.0182ZM23 19.0701L17.7272 22.2338V16.618L23 13.9816V19.0701ZM15.2727 9.11794L21.764 12.3636L20.7272 12.8819L14.236 9.63632L15.2727 9.11794ZM10.236 11.6363L11.9999 10.7543L18.4912 14L16.7272 14.8819L10.236 11.6363Z"
            fill={color}
        />
    </svg>
);
